export default __webpack_public_path__ + "static/sc1-265d455aaea5ce2fd436f6e4bd40be1d.png";